module.exports = __webpack_public_path__ + "img/avatar_4.5a1de5de.jpg";